import React, { useState, useEffect, useCallback } from 'react';
import DateLabelInput from '../common/forms/DateLabelInput';
import LabelInput from '../common/forms/Labelinput';
import SelectMenu from '../common/forms/selectmenu';
import Button from '../common/ui/button';
import CancelButton from '../common/ui/cancelbutton';
import { ChevronDown, ChevronUp } from 'lucide-react';
import NoFound from '../common/ui/NoFound';
import { API_CONFIG, getHeaders, refreshAccessToken } from "../../config/api";
import toast from 'react-hot-toast';
import { MdEditSquare } from 'react-icons/md';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { useAuth } from "../../context/AuthContext";
import { DeletePreviewModal, FinalDeleteConfirmModal } from "../common/ui/deletemodal";
import { useNavigate } from "react-router-dom";
import WarningModal from '../common/ui/warningmodel';

export default function Editdispatchform({
  entries = [],
  editEntry,
  onAddEntry,
  onEditEntry,
  onDeleteEntry,
  onUpdateEntry,
  setOnRestoreItem,
  biNumberOptions = [],
  loadingBINumber = false,
}) {
  const [formData, setFormData] = useState({
    dispatchDate: "",
    weight: "",
    truckno: "",
    binumber: "",
    binumber_id: "",
  });
  const selectedDispatchMasterId = entries?.[0]?.dispatch_master_id || 0;
  let selecteddispatchchildId = null;
  const [pendingDeleteData, setPendingDeleteData] = useState(null);
  const [deleteMode, setDeleteMode] = useState(null); // "child"
  const [showDeletePreview, setShowDeletePreview] = useState(false);
  const [showFinalDeleteConfirm, setShowFinalDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [records, setRecords] = useState(entries || []);
  const [inboundFullDataResult, setinboundFullDataResult] = useState([]);
  const [items, setItems] = useState([]);
  const [loadingExbond, setLoadingExbond] = useState(false);
  const [openExbond, setOpenExbond] = useState(null);
  const { logout } = useAuth();
  const [warningVisible, setWarningVisible] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  const handleDeleteChild = (child) => {
    setPendingDeleteData({ child });
    setDeleteMode("child");
    setShowDeletePreview(true);
    setShowFinalDeleteConfirm(false);
  };
  const handleCancelPreview = () => {
    setShowDeletePreview(false);
    setPendingDeleteData(null);
    setDeleteMode(null);
  };
  const handleProceedToFinalConfirm = () => {
    setShowDeletePreview(false);
    setShowFinalDeleteConfirm(true);
  };
  const handleConfirmDelete = async () => {
    if (!pendingDeleteData) return;

    const child = pendingDeleteData.child;

    setLoading(true);

    try {
      // Check if this is a new entry (frontend only)
      const isNewRecord = !child.id;

      if (isNewRecord) {
        // ✅ Delete new entry locally
        setRecords(prev => prev.filter(r => r.tempId !== child.tempId));
        toast.success("New entry removed successfully");
      } else {
        // ✅ Delete old entry from backend
        const childId = child.id;
        let response = await fetch(
          `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.DISPATCH.SOFT_DELETE_PARTIAL(childId)}`,
          { method: "PUT", headers: getHeaders(true) }
        );

        // Retry if token expired
        if (response.status === 401) {
          const newToken = await refreshAccessToken();
          if (newToken) {
            response = await fetch(
              `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.DISPATCH.SOFT_DELETE_PARTIAL(childId)}`,
              { method: "PUT", headers: getHeaders(true) }
            );
          } else {
            console.error("Token refresh failed");
            return;
          }
        }

        const result = await response.json().catch(() => ({}));
        if (response.ok && result.status === 200) {
          toast.success(result.message || "Child deleted successfully");
          setRecords(prev => prev.filter(r => r.id !== childId));
          navigate("/dispatch");
        } else {
          setWarningMessage(result.message || "Failed to delete child");
          setWarningVisible(true);

        }
      }
    } catch (err) {
      console.error(err);
      setWarningMessage("Unexpected error while deleting entry");
      setWarningVisible(true);
    } finally {
      setLoading(false);
      setShowFinalDeleteConfirm(false);
      setPendingDeleteData(null);
      setDeleteMode(null);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${day} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };
  const handleCheckEdit = async (id) => {
    selecteddispatchchildId = id
  };

  // --- Fetch Exbond data for selected BI Number ---
  const fetchInbondExbondFullList = useCallback(async (binumberId = formData.binumber_id) => {
    if (!binumberId) return;
    setLoadingExbond(true);
    try {
      let response = await fetch(
        `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.DISPATCH.GET_INBOND_FULL_DATA(binumberId)}`,
        { method: "GET", headers: getHeaders(true) }
      );

      if (response.status === 401) {
        const newToken = await refreshAccessToken();
        if (newToken) {
          response = await fetch(
            `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.DISPATCH.GET_INBOND_FULL_DATA(binumberId)}`,
            { method: "GET", headers: getHeaders(true) }
          );
        } else {
          logout();
          return;
        }
      }

      const json = await response.json();
      setinboundFullDataResult(json);

      const exbondItems = rebuildExbondItems(json, editEntry);
      setItems(exbondItems);

      if (editEntry) {
        const exists = exbondItems.some((item) => item.id === editEntry.itemId);
        if (!exists) {
          exbondItems.push({
            id: editEntry.itemId,
            exbondNo: editEntry.exbondNo,
            material: editEntry.material,
            customer: editEntry.customer,
            weight: editEntry.weight,
            checked: true,
          });
        } else {
          exbondItems.forEach((item) => {
            if (item.id === editEntry.itemId) item.checked = true;
          });
        }
      }

      setItems(exbondItems.filter((item) => item.weight > 0));
    } catch (error) {
      console.error("Error fetching Exbond list:", error);
      setItems([]);
    } finally {
      setLoadingExbond(false);
    }
  }, [editEntry, formData.binumber_id, logout]);



  useEffect(() => {
    fetchInbondExbondFullList();
  }, [fetchInbondExbondFullList]);

  // --- Handle edit entry ---
  useEffect(() => {
    if (editEntry) {
      const selectedOption = biNumberOptions.find(
        (opt) => opt.binumber === editEntry.binumber
      );

      const updatedFormData = {
        dispatchDate: editEntry.dispatchDate || "",
        weight: editEntry.dispatchWeight || "",
        truckno: editEntry.truckNo || "",
        binumber: editEntry.binumber || "",
        binumber_id: selectedOption?.value || "",
      };

      setFormData(updatedFormData);
      fetchInbondExbondFullList(updatedFormData.binumber_id);
    }
  }, [editEntry, biNumberOptions, fetchInbondExbondFullList]);

  // --- Handle checkbox toggle ---
  const handleCheckbox = (childId) => {
    setItems(prev => prev.map(item => item.id === childId ? { ...item, checked: !item.checked } : item));
  };

  // --- Add or update entry ---
  const isFormComplete = formData.dispatchDate && formData.weight && formData.truckno && formData.binumber;
  const isItemSelected = Array.isArray(items) && items.some(item => item.checked);
  const canAddEntry = isFormComplete && isItemSelected;

  const applyDispatchWeightUpdate = (entry) => {
    const exbondList = inboundFullDataResult?.data?.exbond_data;

    if (!Array.isArray(exbondList)) {
      console.error("exbond_data is not an array");
      return;
    }
    exbondList.forEach(exbond => {

      exbond.data.forEach(material => {

        material.data.forEach(dispatch => {

          if (dispatch.dispatch_child_id === entry.dispatch_child_id) {
            dispatch.dispatch_weight = parseFloat(entry.dispatchWeight);
          }
        });
      });

    });
  };

  const getTotalDispatchedByMasterId = (fullData, targetMasterId) => {
    let total = 0;

    fullData?.data?.exbond_data?.forEach((exbond) => {
      exbond.data?.forEach((child) => {
        child.data?.forEach((dispatch) => {
          if (dispatch.dispatch_master_id === targetMasterId) {
            total += parseFloat(dispatch.dispatch_weight || 0);
          }
        });
      });
    });

    return total;
  };

  const rebuildExbondItems = (fullData, editEntry = null) => {

    const exbondItems = [];

    fullData?.data?.exbond_data?.forEach((exbond) => {
      exbond.data.forEach((child) => {
        const dispatchedWeight = child.data?.reduce(
          (sum, d) => sum + parseFloat(d.dispatch_weight || 0),
          0
        );

        exbondItems.push({
          id: child.exbond_child_id,
          exbondNo: exbond.exbond_id,
          material: child.material_name,
          customer: child.customer_name,
          exbond_be_date: child.exbond_be_date,
          material_short_code: child.material_short_code,
          weight: parseFloat(child.weight) - dispatchedWeight,
          originalWeight: parseFloat(child.weight),
          checked: false,
          hellodispatchedWeight: dispatchedWeight,
        });
      });
    });

    // Attach edit entry if needed
    if (editEntry) {
      const exists = exbondItems.some((item) => item.id === editEntry.itemId);

      if (!exists) {
        // Add the edited item if not present in the fetched list
        exbondItems.push({
          id: editEntry.itemId,
          exbondNo: editEntry.exbondNo,
          material: editEntry.material,
          customer: editEntry.customer,
          weight: editEntry.weight,
          checked: true,
          totaldispatchedWeight: editEntry.dispatchedWeight,
        });
      } else {
        // If present, just mark checked and update total dispatched weight
        exbondItems.forEach((item) => {
          if (item.id === editEntry.itemId) {
            item.checked = true;
            item.totaldispatchedWeight = editEntry.dispatchedWeight;
          }
        });
      }
    }

    // Filter items that still have weight left
    return exbondItems.filter((item) => item.weight > 0);
  };




  const handleUpdateItem = () => {
    if (!canAddEntry) return;


    if (editEntry) {
      // --- UPDATE EXISTING ENTRY ---



      const updated = {
        ...editEntry,
        dispatchDate: formData.dispatchDate,
        dispatchWeight: formData.weight,
        truckNo: formData.truckno,
        binumber: formData.binumber,
        binumber_id: formData.binumber_id,
        id: editEntry.id,
      };
      applyDispatchWeightUpdate(updated);
      const updatedItems = rebuildExbondItems(inboundFullDataResult, updated);
      setItems(updatedItems);
      const totalWeightByDispachedMasterId = getTotalDispatchedByMasterId(inboundFullDataResult, selectedDispatchMasterId)
      console.log("totalWeihtByDispachedMasterId", totalWeightByDispachedMasterId);
      const updatedWithTotal = {
        ...updated,
        totalWeightByDispachedMasterId
      };


      onUpdateEntry(updatedWithTotal);




      // --- RESET FORM + EXIT EDIT MODE ---
      resetForm();
      onEditEntry(null);

      return;
    }

    // ADD FLOW (if needed)
  };
  const resetForm = () => {
    // Reset only inputs
    setFormData(prev => ({
      ...prev,
      weight: "",
    }));

    // Restore items to ORIGINAL API values
    if (inboundFullDataResult) {
      const originalItems = rebuildExbondItems(inboundFullDataResult, editEntry);
      setItems(originalItems);
    }
  };

  const formatIndianNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "0";
    return Number(num).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };


  return (
    <>
      <div className="space-y-2 w-full">
        <div className="grid grid-cols-1 xl:grid-cols-12 lg:grid-cols-12 md:grid-cols-12 gap-x-6 gap-y-4 items-start">
          {/* LEFT SIDE FORM */}
          <div className="lg:col-span-4 col-span-12 bg-white shadow-md border border-gray-100 rounded p-4 sm:p-5 space-y-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <div className="relative overflow-visible z-50">
                <SelectMenu
                  label="BI No."
                  options={biNumberOptions}
                  value={formData.binumber}
                  onChange={(value) => {
                    const selected = biNumberOptions.find((opt) => opt.value === value);

                    setFormData(prev => ({
                      ...prev,
                      binumber: selected?.binumber || "",     // BI Number text
                      binumber_id: value,                     // inbond_master_id (ID)
                    }));
                  }}

                  searchable
                  required
                  usePortal
                  loading={loadingBINumber}
                  placeholder={loadingBINumber ? "Loading..." : "Select BI No"}
                />
              </div>
              <SelectMenu
                label="Exbond No."
                options={[
                  { label: inboundFullDataResult?.data?.exbond_data?.map(exbond => exbond.exbond_id).join(", ") || "", value: "exbond" }
                ]}
                value={
                  inboundFullDataResult?.data?.exbond_data
                    ?.map(exbond => exbond.exbond_id)
                    .join(", ") || ""
                }
                disabled
              />

            </div>
            {/* Exbond table */}
            <div className="overflow-hidden">
              <div className="overflow-y-auto overflow-x-auto mb-5">
                <table className="min-w-full border-collapse text-table text-gray-700 text-sm sm:text-[13px]">
                  <thead className="border-b border-gray-200 sticky top-0 z-10 shadow-sm bg-white">
                    <tr>
                      <th className="px-3 py-2 w-10 text-center"></th>
                      <th className="px-4 py-2 text-center whitespace-nowrap">Material</th>
                      <th className="px-4 py-2 text-center whitespace-nowrap">Weight</th>
                      <th className="px-4 py-2 text-center whitespace-nowrap">Customer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingExbond ? (
                      <tr>
                        <td colSpan="5" className="px-3 py-3 text-center text-gray-400">
                          Loading Exbond data...
                        </td>
                      </tr>
                    ) : !formData.binumber ? (
                      <tr>
                        <td colSpan="5" className="px-3 py-3 text-center text-gray-400">
                          Please select a BE No
                        </td>
                      </tr>
                    ) : items.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="px-3 py-3 text-center text-gray-400">
                          No Exbond data found
                        </td>
                      </tr>
                    ) : (
                      Object.entries(
                        items.reduce((groups, item) => {

                          // check if this item.exbondNo exists in entries
                          const exists = entries.some(entry => entry.exbondNo === item.exbondNo);

                          if (exists) {
                            if (!groups[item.exbondNo]) groups[item.exbondNo] = [];
                            groups[item.exbondNo].push({
                              ...item,
                              ...(item.id === selecteddispatchchildId ? { checked: true } : {})
                            });

                          }

                          return groups; // <-- always return groups
                        }, {})
                      ).map(([exbondNo, group]) => (

                        <ExbondRow
                          key={exbondNo}
                          exbondNo={exbondNo}
                          group={group}
                          handleCheckbox={handleCheckbox}
                          openExbond={openExbond}
                          setOpenExbond={setOpenExbond}
                        />
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <div className="relative overflow-visible z-50">
                <DateLabelInput
                  label="Dispatch Date"
                  name="dispatchDate"
                  type="date"
                  value={formData.dispatchDate}
                  onChange={e => setFormData(prev => ({ ...prev, dispatchDate: e.target.value }))}
                />
              </div>
              <LabelInput
                label="Truck No."
                type="text"
                name="truckno"
                required
                value={formData.truckno}
                onChange={e => setFormData(prev => ({ ...prev, truckno: e.target.value }))}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              <LabelInput
                label="Dispatch Weight"
                type="text"
                name="weight"
                required
                value={formData.weight}
                onChange={e => setFormData(prev => ({ ...prev, weight: e.target.value }))}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-3">
              <Button type="button" onClick={handleUpdateItem} disabled={!canAddEntry} className="w-full">
                {loading ? "Updating..." : "Update Entry"}
              </Button>
              <CancelButton
                type="button"
                onClick={resetForm}
                className="w-full"
              >
                Reset
              </CancelButton>
            </div>


          </div>

          {/* RIGHT SIDE Table */}
          <div className="lg:col-span-8 col-span-12">
            <div className="w-full pt-5">
              {entries.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="w-full text-[11px] text-center">
                    <thead className="h-10 border-b border-gray-200 text-gray-600 font-medium">
                      <tr>
                        <th>BI Number</th>
                        <th>Exbond Number</th>
                        <th>Material</th>
                        <th>Exbond Weight</th>
                        <th>Customer</th>
                        <th>Dispatch Date</th>
                        <th>Dispatch Weight</th>
                        <th>Truck No.</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {entries.map((entry, i) => (
                        <tr key={i} className="border-t h-10 border-gray-100 hover:bg-gray-50">
                          <td>{entry.binumber.toUpperCase()}</td>
                          <td>{`EI${entry.exbondNo}`}</td>
                          <td>{entry.material ? entry.material.charAt(0).toUpperCase() + entry.material.slice(1) : ""}</td>
                          <td>{formatIndianNumber(entry.weight)}</td>
                          <td>{entry.customer ? entry.customer.charAt(0).toUpperCase() + entry.customer.slice(1) : ""}</td>
                          <td>{formatDate(entry.dispatchDate)}</td>
                          <td>{formatIndianNumber(entry.dispatchWeight)}</td>
                          <td>{entry.truckNo.toUpperCase()}</td>
                          <td>
                            <div className="flex items-center justify-center space-x-1">
                              <button
                                id={entries[i]?.dispatch_child_id}
                                onClick={() => {
                                  onEditEntry(entries[i]);
                                  handleCheckEdit(entries[i]?.dispatch_child_id);
                                }}
                                className="text-green-500 hover:text-green-700 p-1" title="Edit Entry">
                                <MdEditSquare size={18} />
                              </button>
                              <button onClick={() => handleDeleteChild(entries[i])} className="text-red-500 hover:text-red-700 p-1" title="Delete Entry">
                                <RiDeleteBin5Line size={18} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : <NoFound />}
            </div>
          </div>
        </div>
      </div>
      {/* Modals */}
      {/* Delete preview modal for parent or child */}
      {showDeletePreview && pendingDeleteData && (
        <DeletePreviewModal
          title={deleteMode === "parent" ? "Exbond Details" : "Child Entry Details"}
          data={
            deleteMode === "parent"
              ? {
                "Exbond No.": pendingDeleteData.parent?.exbondNo,
                "Total Exbond Weight": pendingDeleteData.parent?.total_weight,
              }
              : {
                "BI No.": pendingDeleteData.child?.binumber,
                "Exbond No.": pendingDeleteData.child?.exbondNo || pendingDeleteData.child?.beNumber,
                "Material": pendingDeleteData.child?.material,
                "Exbond Weight": pendingDeleteData.child?.weight,
                "Customer": pendingDeleteData.child?.customer,
                "Dispatch Date": pendingDeleteData.child?.dispatchDate
                  ? formatDate(pendingDeleteData.child.dispatchDate)
                  : "",
                "Dispatch Weight": pendingDeleteData.child?.dispatchWeight || pendingDeleteData.child?.dispatch_weight,
                "Truck No.": pendingDeleteData.child?.truckNo || pendingDeleteData.child?.truck_no,
              }
          }
          onCancel={handleCancelPreview}
          onProceed={handleProceedToFinalConfirm}
        />
      )}



      {/* Final delete confirm modal */}
      {showFinalDeleteConfirm && pendingDeleteData && (
        <FinalDeleteConfirmModal
          title="Confirm Delete"
          message="Are you sure you want to permanently delete this entry?"
          onCancel={() => {
            setShowFinalDeleteConfirm(false);
            setPendingDeleteData(null);
            setDeleteMode(null);
          }}
          onConfirm={handleConfirmDelete}
        />
      )}
      {warningVisible && (
        <WarningModal
          message={warningMessage}
          onClose={() => setWarningVisible(false)}
        />
      )}
    </>
  );
}

// --- Exbond Row ---
function ExbondRow({ exbondNo, group, handleCheckbox, openExbond, setOpenExbond }) {
  const isOpen = openExbond === exbondNo;
  const toggleOpen = () => setOpenExbond(isOpen ? null : exbondNo);
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${day} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };
  const rowHeight = 40;
  const maxVisibleRows = 2;
  const scrollHeight = rowHeight * maxVisibleRows;
  return (
    <>
      <tr className="border-y border-gray-200 cursor-pointer hover:bg-gray-100 transition" onClick={toggleOpen}>
        <td className="px-2 py-2 text-center">
          <div className="inline-flex items-center justify-center p-1 rounded hover:bg-sidebarHover">
            {isOpen ? <ChevronUp className="w-4 h-4 text-gray-600" /> : <ChevronDown className="w-4 h-4 text-gray-600" />}
          </div>
        </td>
        <td colSpan="3" className="px-4 py-2 font-semibold text-gray-800 text-left whitespace-nowrap">
          Exbond No: <span className="text-primary font-bold">{exbondNo}</span>
        </td>
      </tr>

      {isOpen && (
        <tr>
          <td colSpan="4" className="p-0">
            <div className="overflow-y-auto" style={{ maxHeight: `${scrollHeight}px` }}>
              <table className="min-w-full border-collapse text-table text-gray-700 text-sm sm:text-[13px]">
                <tbody>
                  {group.map((item) => (
                    <tr key={item.id} className="border-b border-gray-100 hover:bg-gray-50 transition">
                      <td className="px-3 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={item.checked}
                          onChange={() => handleCheckbox(item.id)}
                          onClick={(e) => e.stopPropagation()}
                          className="cursor-pointer accent-primary w-4 h-4"
                        />
                      </td>
                      <td className="px-4 py-2 text-center whitespace-nowrap">
                        <div className="flex flex-col items-center">
                          <span>{item.material} ({item.material_short_code ? item.material_short_code.toUpperCase() : ""})</span>

                          <span className="text-[10px] text-gray-500">{formatDate(item.exbond_be_date)}</span>
                        </div>
                      </td>
                      <td className="px-4 py-2 text-center whitespace-nowrap">{item.weight}</td>
                      <td className="px-4 py-2 text-center whitespace-nowrap">{item.customer}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      )}

    </>
  );
}
